export default {
  namespaced: true,
  state: {
    maintenance: 0,
    sms: null,
    alertActive: false,
    alerts: [],
    androidVersion: null,
    iosVersion: null,
    number_regex: null,
    google_recaptcha: null,
    mandatory_chassis_for_vignette: null,
    disabled_payment_methods: []
  },
  mutations: {
    setSettings(state, settings) {
      state.maintenance = settings.maintenance.value;
      state.alerts = settings.alerts;
      state.sms = settings.sms;
      state.androidVersion = settings.android_version;
      state.iosVersion = settings.ios_version;
      state.number_regex = settings.number_regex;
      state.mandatory_chassis_for_vignette = settings.mandatory_chassis_for_vignette;
      state.disabled_payment_methods = settings.disabled_payment_methods;
      state.google_recaptcha = {
        recaptcha_v3: settings.google_recaptcha_v3_public,
        recaptcha_v2: settings.google_recaptcha_v2_public,
      };
      if (Object.keys(state.alerts).length) {
        state.alertActive = true;
      }
    },
  },
  actions: {
    getSettings({ commit }) {
      return this.$axios.get("/settings").then((response) => {
        commit("setSettings", response.data.settings);
        return response.data.settings;
      });
    },
  },
  getters: {
    getMaintenance({ maintenance }) {
      return maintenance;
    },
    getSmsSetting({ sms }) {
      return sms;
    },
    getSmsSettingMessage({ sms }) {
      return (value = null) => {
        if(value != null) {
          return `${value} ${value > 1 ? 'lei' : 'leu'}`
        }

        let smsValue = sms?.value % 1 === 0 ? parseFloat(sms?.value).toFixed(0) : parseFloat(sms?.value).toFixed(2);

        return sms?.extra?.active == 1 && sms?.extra?.message?.length ? sms?.extra?.message : `${smsValue} ${sms.value > 1 ? 'lei' : 'leu'}`
      };
    },
    isAlertActive({ alertActive }) {
      return alertActive;
    },
    getAlerts({ alerts }) {
      return (type) => {
        return typeof alerts[type] !== "undefined" ? alerts[type] : null;
      };
    },
    getAppVersion(state) {
      return (device) => {
        return device == "ios"
          ? state.iosVersion != null
            ? state.iosVersion["extra"]
            : 0
          : state.androidVersion != null
          ? state.androidVersion["extra"]
          : 0;
      };
    },
    getNumberRegex({ number_regex }) {
      return number_regex;
    },
    getGoogleRecaptcha({ google_recaptcha }) {
      return google_recaptcha;
    },
    getMandatoryChassisForVignette({ mandatory_chassis_for_vignette }) {
      return mandatory_chassis_for_vignette;
    },
    getDisabledPaymentMethods({ disabled_payment_methods }) {
      return disabled_payment_methods;
    }
  },
};
